import React from "react"

export const buildStackedBarChartData = obj => {
  const { datasets, labels } = obj.data

  const data = labels.map((label, index) => {
    let object = {}
    object["0"] = label
    datasets.forEach(item => {
      object[item.label] = item.data[index]
    })

    return object
  })
  return data
}

export const buildBarChartData = obj => {
  const { datasets, labels } = obj.data
  let object = {}

  labels.forEach((label, index) => {
    // The labels are sometimes formatted in chart.js as arrays so need to turn them into strings
    let formmatedlabel = typeof label === "string" ? label : label.join(" ")
    object[formmatedlabel] = datasets[0].data[index]
  })

  return [object]
}

export function computedPxToNumber(element, style) {
  const string = window.getComputedStyle(element)[style]

  if (string.endsWith("px")) {
    return parseFloat(string.slice(0, -2))
  }
}

export const formatSource = text => {
  const toHTML = text
    .replace(/\/n/g, "<br/>") // line breaks
    .replace(/\*\*(.+?)\*\*/gm, '<b>$1</b>')// bold text
    .replace( /\*(.+?)\*/gm, '<i>$1</i>') // italic text
  return <span dangerouslySetInnerHTML={{ __html: toHTML.trim() }} /> // using trim method to remove whitespace
}
